import script from "./WorkItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkItem.vue?vue&type=script&setup=true&lang=ts"

import "./WorkItem.vue?vue&type=style&index=0&id=6d850268&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d850268"]])

export default __exports__